import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { WINTER_RADAR_MOSAIC_LEGEND } from './winter-radar-reflectivity.legend';
import { RADAR_FCST_PRODUCT_DATA } from './winter-radar-reflectivity.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class WinterRadarReflectivityPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(RADAR_FCST_PRODUCT_DATA, {
    legend: WINTER_RADAR_MOSAIC_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
